import type { FPlusScopeOutput } from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useFPlusScopeFilterValue } from '../../context/fPlusScopeFilterValueContext'

export const useFilteredScope = (scope: Optional<FPlusScopeOutput>) => {
  const { filterValue } = useFPlusScopeFilterValue()

  return useMemo(() => {
    if (!filterValue || filterValue.length === 0 || !scope) {
      return scope
    }

    const filterValueIgnoreCase = filterValue.toLowerCase()

    return {
      environment: {
        _type: 'FPlusEnvironmentScopeOutput',
        ...scope.environment,
        variables: scope.environment?.variables?.filter((variable) =>
          variable?.propertyName?.toLowerCase().includes(filterValueIgnoreCase),
        ),
      },
      defaultImportedLibraries: scope.defaultImportedLibraries
        ?.map((library) => ({
          _type: 'FPlusLibraryScopeOuput',
          ...library,
          functions: library?.functions?.filter((func) =>
            func?.functionName?.toLowerCase().includes(filterValueIgnoreCase),
          ),
        }))
        .filter((library) => !!library?.functions?.length),
      contexts: scope.contexts
        ?.map((context) => ({
          _type: 'FPlusContextScopeOutput',
          ...context,
          functions: context?.functions?.filter((func) =>
            func?.functionName?.toLowerCase().includes(filterValueIgnoreCase),
          ),
          variables: context?.variables?.filter((variable) =>
            variable?.propertyName
              ?.toLowerCase()
              .includes(filterValueIgnoreCase),
          ),
        }))
        .filter(
          (context) =>
            !!context?.functions?.length || !!context?.variables?.length,
        ),
    }
  }, [scope, filterValue])
}
